import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { BetaAccessLandingComponent } from '../modules/beta-access-landing/beta-access-landing/beta-access-landing.component';
import { PrivacyPolicyComponent } from '../modules/privacy-policy/privacy-policy/privacy-policy.component';
import { NewsletterUnsubscribeComponent } from '../modules/newsletter-unsubscribe/newsletter-unsubscribe/newsletter-unsubscribe.component';
import { AuthComponent } from '../modules/auth/auth/auth.component';
import { AuthGuard } from '../modules/auth/auth/auth.guard';
import { GamesComponent } from '../modules/games/games/games.component';
import { QuizComponent } from '../modules/quiz-constructor/quiz/quiz.component';
import { QuestionGenerationComponent } from '../modules/quiz-constructor/question-generation/question-generation/question-generation.component';
import { QuizListComponent } from '../modules/quiz-constructor/quiz-list/quiz-list.component';
import { QuizEditorComponent } from '../modules/quiz-constructor/quiz-editor/quiz-editor.component';
import { RoomManagerComponent } from '../modules/room-manager/room-manager/room-manager.component';


const routes: Routes = [
    {
        path: '',
        component: BetaAccessLandingComponent
    },
    {
        path: 'privacy-policy',
        component: PrivacyPolicyComponent
    },
    {
        path: 'unsubscribe',
        component: NewsletterUnsubscribeComponent
    },
    {
        path: 'auth',
        component: AuthComponent
    },
    {
        path: 'quiz',
        component: QuizComponent
    },
    {
        path: 'quiz-list',
        component: QuizListComponent,
        // canActivate: [AuthGuard]
    },
    {
        path: 'quiz-editor',
        component: QuizEditorComponent,
        // canActivate: [AuthGuard]
    },
    {
        path: 'question-generation',
        component: QuestionGenerationComponent,
        // canActivate: [AuthGuard]
    },
    {
        path: 'games',
        component: GamesComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'room-manager',
        component: RoomManagerComponent,
        // canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            routes,
            {
                enableTracing: false,
                scrollPositionRestoration: 'enabled',
                relativeLinkResolution: 'legacy'
            }
        )
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
